
    <div [class]="computedTableClasses()">
      <!-- Glass shimmer overlay -->
      <div class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-700 pointer-events-none">
        <div
          class="absolute inset-0 bg-linear-to-r from-transparent via-primary-400/10 to-transparent
                    transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                    transition-transform duration-1000 ease-out rounded-xl"
        ></div>
      </div>

      <div class="relative z-10 overflow-x-auto">
        <table class="w-full">
          <!-- Table Header -->
          <thead [class]="computedHeaderClasses()">
            <tr>
              @for (column of columns; track column.key) {
              <th
                scope="col"
                [class]="getHeaderCellClasses(column)"
                [style.width]="column.width"
                (click)="column.sortable ? handleSort(column.key) : null"
              >
                <div class="flex items-center space-x-2 relative z-10">
                  <span class="font-semibold truncate">{{ column.label }}</span>

                  @if (column.sortable) {
                  <div class="flex flex-col">
                    <svg
                      class="w-3 h-3 transition-colors"
                      [class.text-primary-500]="sortColumn === column.key && sortDirection === 'asc'"
                      [class.text-gray-400]="sortColumn !== column.key || sortDirection !== 'asc'"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      />
                    </svg>
                  </div>
                  }
                </div>

                <!-- Header glass accent -->
                <div
                  class="absolute inset-0 bg-linear-to-r from-primary-500/5 to-transparent
                              opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                ></div>
              </th>
              }
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody class="relative">
            @for (item of sortedData(); track trackByFn ? trackByFn($index, item) : $index; let i = $index) {
            <tr [class]="getRowClasses(item, i)" (click)="handleRowClick(item, i)" [attr.data-index]="i">
              @for (column of columns; track column.key) {
              <td [class]="getCellClasses(column, item)">
                <div class="relative z-10">
                  <!-- Custom template or default content -->
                  @if (column.template) {
                  <ng-container
                    [ngTemplateOutlet]="column.template"
                    [ngTemplateOutletContext]="{ $implicit: item, column: column, index: i }"
                  ></ng-container>
                  } @else {
                  <span class="truncate block">{{ getNestedValue(item, column.key) }}</span>
                  }
                </div>
              </td>
              }

              <!-- Row hover glass effect -->
              <div
                class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300
                            bg-linear-to-r from-transparent via-white/5 to-transparent pointer-events-none"
              ></div>
            </tr>
            }

            <!-- Empty state -->
            @if (data.length === 0) {
            <tr>
              <td [attr.colspan]="columns.length" class="text-center py-12 text-gray-700 dark:text-gray-200">
                <div class="flex flex-col items-center space-y-3">
                  <div
                    class="w-16 h-16 bg-primary-100/50 dark:bg-primary-900/30 rounded-full flex items-center justify-center backdrop-blur-sm"
                  >
                    <svg
                      class="w-8 h-8 text-primary-600 dark:text-primary-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                      />
                    </svg>
                  </div>
                  <span class="text-lg font-semibold">{{ emptyMessage }}</span>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Premium floating accents -->
      @if (variant === 'premium') {
      <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-30">
        <div class="absolute top-1/4 left-1/6 w-2 h-2 bg-primary-400/40 rounded-full animate-pulse"></div>
        <div class="absolute bottom-1/3 right-1/4 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse delay-1000"></div>
        <div class="absolute top-3/4 left-3/4 w-1 h-1 bg-primary-300/50 rounded-full animate-pulse delay-2000"></div>
      </div>
      }
    </div>
  